import React from 'react';
import { Store, UtensilsCrossed, Factory, Package2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Industries = () => {
  const { t } = useLanguage();

  const industries = [
    {
      icon: Store,
      title: t.industries.retail.title,
      description: t.industries.retail.description,
      image: 'https://images.unsplash.com/photo-1579113800032-c38bd7635818'
    },
    {
      icon: UtensilsCrossed,
      title: t.industries.hospitality.title,
      description: t.industries.hospitality.description,
      image: 'https://images.unsplash.com/photo-1597362925123-77861d3fbac7'
    },
    {
      icon: Factory,
      title: t.industries.manufacturing.title,
      description: t.industries.manufacturing.description,
      image: 'https://images.pexels.com/photos/7890065/pexels-photo-7890065.jpeg'
    },
    {
      icon: Package2,
      title: t.industries.wholesale.title,
      description: t.industries.wholesale.description,
      image: 'https://images.unsplash.com/photo-1610444833641-0542660a4ed7'
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center">
        <div
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1498579397066-22750a3cb424)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0 bg-black opacity-60"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <h1 className="text-5xl font-bold mb-4">{t.industries.hero.title}</h1>
          <p className="text-xl text-gray-200">{t.industries.hero.subtitle}</p>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {industries.map((industry, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow"
              >
                <div className="relative h-64">
                  <img
                    src={industry.image}
                    alt={industry.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
                </div>
                <div className="p-8">
                  <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                    <industry.icon className="w-7 h-7 text-red-600" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {industry.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {industry.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;
